import { useOriginLink } from "../../../app/navigation/return-navigation.js";
import { BrainCircuit } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ActionLink } from "../../../app/components/ActionLink.js";

export function AreaAssessmentEntry({ pageId, title }: { pageId: string; title: string }) {
  const { t } = useTranslation();
  const originLink = useOriginLink();
  return (
    <ActionLink
      controlId="passport.area-assessment.open"
      to={originLink(`/me/assessment/${pageId}`)}
      icon={<BrainCircuit className="size-5" />}
      title={t("areaAssessment.entryTitle")}
      description={t("areaAssessment.entryDescription", { area: title })}
    />
  );
}
